export default __webpack_public_path__ + "static/Thank-you-2023-recap-ef02495f39b74d454f6559609bb2f7c2.png";